import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { plsPlayerAccountsShape } from 'utils/plsShapes';
import CardsIcon from './acc-cards-icon.svg';
import './PlayerCardsPopover.css';

const PlayerCardsPopover = ({ playerId, accounts }) => {
  const playerActiveCards = playerCards =>
    playerCards.map((acc, idx) => {
      return (
        <div key={idx} className="card-container">
          <div className="type">{acc.cardType}</div>
          <div className="card-num">{acc.cardNumber}</div>
        </div>
      );
    });

  const playerAccounts = accounts.map((acc, idx) => {
    return (
      <div className="pls-account-container" key={idx}>
        <div className="account">
          <span>Account:</span> {acc.plsAccountNumber}
        </div>
        <div className="active-player-cards">
          {playerActiveCards(acc.playerCards)}
        </div>
      </div>
    );
  });

  return (
    <OverlayTrigger
      trigger="click"
      placement="top"
      rootClose
      overlay={
        <Popover id={`player-cards-popover`}>
          <Popover.Header as="h3">Your Active Cards</Popover.Header>
          <Popover.Body>
            <div>
              <span>Player ID:</span> {playerId}
            </div>
            {playerAccounts}
          </Popover.Body>
        </Popover>
      }
    >
      <button className="acc-cards-icon" type="button">
        <img src={CardsIcon} alt="View Player Cards" />
      </button>
    </OverlayTrigger>
  );
};

PlayerCardsPopover.propTypes = {
  playerId: PropTypes.string,
  accounts: plsPlayerAccountsShape
};

export default PlayerCardsPopover;
